import * as React from "react";
import { DriveSkeleton } from "@/views/drive/driveSkeleton";
import { useSearchParams } from "react-router";
import { FileItem, FolderItem, Item } from "@/types/fse";
import { createBreadCrumbs } from "./helpers";
import { DriveHeader } from "./driveHeader";
import { DriveSearch } from "./driveSearch";
import { DriveList } from "./driveList";
import { Pagination } from "@/views/drive/pagination";

interface DriveBasePageProps {
  totalPages: number;
  isRootDirectory: boolean;
  isLoading: boolean;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  itemsPerPage: number;
  displayItems: Item[];
  error: Error | null | unknown;
  data: FileItem | FolderItem | undefined;
  folderId?: string | undefined;
}

export const DriveBasePage: React.FC<DriveBasePageProps> = ({
  isLoading,
  isRootDirectory,
  error,
  displayItems,
  itemsPerPage,
  totalPages,
  currentPage,
  setCurrentPage,
  data,
  folderId,
}) => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || undefined;

  if (isLoading) {
    return <DriveSkeleton />;
  }

  if (error) {
    return <div>Error occurred</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const [currentFolder, parentFolder] = createBreadCrumbs({ isRootDirectory, data });

  return (
    <div className="mx-auto p-8">
      {currentFolder && (
        <DriveHeader
          parentFolder={parentFolder}
          currentFolder={currentFolder}
          askAIButton={true}
          addFilesButton={true}
        />
      )}
      <DriveSearch folderId={folderId} />
      <DriveList
        sortItemsByDate={!query}
        items={displayItems}
        parentFolder={parentFolder}
        isRootFolder={isRootDirectory}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
    </div>
  );
};
